// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import {
//   NewspaperIcon,
//   CalendarIcon,
//   UserIcon,
//   EyeIcon,
//   ClockIcon,
//   PhotoIcon,
//   VideoCameraIcon,
//   DocumentIcon,
//   ArrowRightIcon,
//   ShareIcon,
//   HeartIcon,
//   BookmarkIcon,
//   ChatBubbleLeftRightIcon,
//   MusicalNoteIcon,
//   TrophyIcon,
//   AcademicCapIcon,
//   GlobeAltIcon,
//   BuildingLibraryIcon,
//   SparklesIcon,
//   RocketLaunchIcon,
//   PlusIcon,
//   PencilIcon,
//   TrashIcon,
//   XMarkIcon
// } from '@heroicons/react/24/outline';

// const NewsMedia = () => {
//   const [activeTab, setActiveTab] = useState('all');
//   const [selectedCategory, setSelectedCategory] = useState('all');
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [editingNews, setEditingNews] = useState(null);
//   const [showDeleteConfirm, setShowDeleteConfirm] = useState(null);
//   const [isAdmin, setIsAdmin] = useState(false);
//   const [loading, setLoading] = useState(true);

//   // Check if user is admin
//   useEffect(() => {
//     const token = localStorage.getItem('token');
//     const userData = localStorage.getItem('user');
    
//     if (token && userData) {
//       try {
//         const user = JSON.parse(userData);
//         setIsAdmin(user.role === 'admin');
//       } catch (e) {
//         setIsAdmin(false);
//       }
//     }
//     setLoading(false);
//   }, []);

//   const categories = [
//     { id: 'all', label: 'All', icon: NewspaperIcon },
//     { id: 'academic', label: 'Academic', icon: AcademicCapIcon },
//     { id: 'sports', label: 'Sports', icon: TrophyIcon },
//     { id: 'cultural', label: 'Cultural', icon: MusicalNoteIcon },
//     { id: 'events', label: 'Events', icon: CalendarIcon }
//   ];

//   const [news, setNews] = useState([
//     {
//       id: 1,
//       title: 'Annual Sports Day 2025 - A Grand Success',
//       category: 'sports',
//       date: 'March 15, 2025',
//       author: 'Sports Department',
//       image: 'https://images.unsplash.com/photo-1461896836934-bdd6e0e2c5c6?w=800&h=400&fit=crop',
//       excerpt: 'The Annual Sports Day 2025 was celebrated with great enthusiasm and participation from students across all classes.',
//       content: 'The event featured various athletic competitions, team sports, and cultural performances...',
//       views: 1250,
//       comments: 45,
//       featured: true,
//       type: 'news'
//     },
//     {
//       id: 2,
//       title: 'Science Exhibition 2025 - Innovative Projects Showcase',
//       category: 'academic',
//       date: 'February 28, 2025',
//       author: 'Science Department',
//       image: 'https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?w=800&h=400&fit=crop',
//       excerpt: 'Students showcased innovative science projects at the annual Science Exhibition.',
//       content: 'The exhibition featured projects in robotics, environmental science, and sustainable energy...',
//       views: 890,
//       comments: 32,
//       featured: false,
//       type: 'news'
//     },
//     {
//       id: 3,
//       title: 'Cultural Fest 2025 - Celebrating Diversity',
//       category: 'cultural',
//       date: 'February 10, 2025',
//       author: 'Cultural Committee',
//       image: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=800&h=400&fit=crop',
//       excerpt: 'Students from different cultures came together to celebrate the Cultural Fest 2025.',
//       content: 'The cultural fest featured traditional dances, music performances, and food stalls...',
//       views: 2100,
//       comments: 67,
//       featured: true,
//       type: 'news'
//     },
//     {
//       id: 4,
//       title: '📸 School Campus Tour - 2025',
//       category: 'events',
//       date: 'March 10, 2025',
//       author: 'Media Team',
//       image: 'https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=800&h=400&fit=crop',
//       excerpt: 'Take a virtual tour of our beautiful campus with state-of-the-art facilities.',
//       content: 'Explore our 2.5 acre campus with 16,800 sq. ft. of built-up area...',
//       views: 3400,
//       comments: 89,
//       featured: false,
//       type: 'photo'
//     },
//     {
//       id: 5,
//       title: '🎥 Annual Day Celebration 2025',
//       category: 'cultural',
//       date: 'March 5, 2025',
//       author: 'Media Team',
//       image: 'https://img.youtube.com/vi/dQw4w9WgXcQ/hqdefault.jpg',
//       excerpt: 'Watch the highlights of our spectacular Annual Day celebration.',
//       content: 'Students performed traditional dances, plays, and musical performances...',
//       views: 5600,
//       comments: 120,
//       featured: false,
//       type: 'video',
//       videoUrl: 'https://youtube.com/@vidyabharatipublicschoolbhalki'
//     }
//   ]);

//   const [newItem, setNewItem] = useState({
//     title: '',
//     category: 'academic',
//     date: '',
//     author: '',
//     image: '',
//     excerpt: '',
//     content: '',
//     type: 'news',
//     videoUrl: ''
//   });

//   const handleAddNews = () => {
//     if (!newItem.title || !newItem.category || !newItem.date) {
//       alert('Please fill in all required fields');
//       return;
//     }

//     const newsItem = {
//       id: news.length + 1,
//       ...newItem,
//       views: 0,
//       comments: 0,
//       featured: false
//     };

//     setNews([newsItem, ...news]);
//     setShowAddModal(false);
//     setNewItem({
//       title: '',
//       category: 'academic',
//       date: '',
//       author: '',
//       image: '',
//       excerpt: '',
//       content: '',
//       type: 'news',
//       videoUrl: ''
//     });
//   };

//   const handleDeleteNews = (id) => {
//     setNews(news.filter(item => item.id !== id));
//     setShowDeleteConfirm(null);
//   };

//   const handleEditNews = (item) => {
//     setEditingNews(item);
//     setNewItem({
//       title: item.title,
//       category: item.category,
//       date: item.date,
//       author: item.author,
//       image: item.image,
//       excerpt: item.excerpt,
//       content: item.content,
//       type: item.type || 'news',
//       videoUrl: item.videoUrl || ''
//     });
//     setShowAddModal(true);
//   };

//   const filteredNews = selectedCategory === 'all' 
//     ? news 
//     : news.filter(n => n.category === selectedCategory);

//   const featuredNews = news.filter(n => n.featured);
//   const photoGallery = news.filter(n => n.type === 'photo');
//   const videoGallery = news.filter(n => n.type === 'video');

//   // If loading, show spinner
//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Hero Section */}
//       <section className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 text-white py-16">
//         <div className="container mx-auto px-4 text-center">
//           <div className="inline-block bg-white/20 backdrop-blur-lg rounded-full px-6 py-2 mb-4">
//             <span className="text-sm font-medium">📰 News & Media</span>
//           </div>
//           <h1 className="text-4xl md:text-5xl font-bold mb-4">News & Media</h1>
//           <p className="text-xl text-blue-100 max-w-3xl mx-auto">
//             Stay updated with the latest happenings, events, and achievements at Vidya Bharati Public School, Bhalki.
//           </p>
//         </div>
//       </section>

//       {/* Admin Controls - ONLY VISIBLE TO ADMIN */}
//       {isAdmin && (
//         <section className="bg-white border-b border-gray-200 py-4">
//           <div className="container mx-auto px-4 flex justify-between items-center">
//             <div className="text-sm text-gray-500">
//               📊 {news.length} Total Posts
//             </div>
//             <button
//               onClick={() => {
//                 setEditingNews(null);
//                 setNewItem({
//                   title: '',
//                   category: 'academic',
//                   date: '',
//                   author: '',
//                   image: '',
//                   excerpt: '',
//                   content: '',
//                   type: 'news',
//                   videoUrl: ''
//                 });
//                 setShowAddModal(true);
//               }}
//               className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-4 py-2 rounded-lg hover:shadow-lg transition flex items-center gap-2"
//             >
//               <PlusIcon className="h-5 w-5" />
//               Add News/Media
//             </button>
//           </div>
//         </section>
//       )}

//       {/* Category Filters */}
//       <section className="bg-white border-b border-gray-200 py-4 sticky top-0 z-10">
//         <div className="container mx-auto px-4">
//           <div className="flex flex-wrap gap-2 justify-center">
//             {categories.map((category) => {
//               const Icon = category.icon;
//               return (
//                 <button
//                   key={category.id}
//                   onClick={() => setSelectedCategory(category.id)}
//                   className={`px-4 py-2 rounded-lg flex items-center gap-2 transition-all duration-300 ${
//                     selectedCategory === category.id
//                       ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg'
//                       : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
//                   }`}
//                 >
//                   <Icon className="h-4 w-4" />
//                   <span className="text-sm font-medium">{category.label}</span>
//                 </button>
//               );
//             })}
//           </div>
//         </div>
//       </section>

//       {/* Featured News */}
//       {featuredNews.length > 0 && (
//         <section className="py-12 bg-white">
//           <div className="container mx-auto px-4">
//             <h2 className="text-2xl font-bold text-gray-800 mb-6">⭐ Featured Stories</h2>
//             <div className="grid md:grid-cols-2 gap-8">
//               {featuredNews.map((item) => (
//                 <div key={item.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition">
//                   <div className="relative">
//                     {item.type === 'video' ? (
//                       <div className="relative w-full h-64 bg-black">
//                         <img src={item.image} alt={item.title} className="w-full h-full object-cover opacity-80" />
//                         <div className="absolute inset-0 flex items-center justify-center">
//                           <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center hover:scale-110 transition">
//                             <svg className="h-8 w-8 text-white" fill="currentColor" viewBox="0 0 24 24">
//                               <path d="M8 5v14l11-7z"/>
//                             </svg>
//                           </div>
//                         </div>
//                       </div>
//                     ) : (
//                       <img src={item.image} alt={item.title} className="w-full h-64 object-cover" />
//                     )}
//                     <span className="absolute top-4 left-4 bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-3 py-1 rounded-full text-xs font-bold">
//                       ⭐ Featured
//                     </span>
//                     <span className={`absolute top-4 right-4 px-3 py-1 rounded-full text-xs font-bold text-white
//                       ${item.category === 'sports' ? 'bg-green-600' : 
//                         item.category === 'academic' ? 'bg-blue-600' : 
//                         item.category === 'cultural' ? 'bg-pink-600' : 'bg-purple-600'}`}
//                     >
//                       {item.category.charAt(0).toUpperCase() + item.category.slice(1)}
//                     </span>
//                     {item.type === 'photo' && (
//                       <span className="absolute bottom-4 right-4 bg-black/50 text-white px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1">
//                         <PhotoIcon className="h-3 w-3" /> Photo
//                       </span>
//                     )}
//                     {item.type === 'video' && (
//                       <span className="absolute bottom-4 right-4 bg-black/50 text-white px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1">
//                         <VideoCameraIcon className="h-3 w-3" /> Video
//                       </span>
//                     )}
//                   </div>
//                   <div className="p-6">
//                     <div className="flex items-center gap-4 text-sm text-gray-500 mb-3">
//                       <span className="flex items-center gap-1"><CalendarIcon className="h-4 w-4" /> {item.date}</span>
//                       <span className="flex items-center gap-1"><UserIcon className="h-4 w-4" /> {item.author}</span>
//                     </div>
//                     <h3 className="text-xl font-bold text-gray-800 mb-2">{item.title}</h3>
//                     <p className="text-gray-600 mb-4">{item.excerpt}</p>
//                     <div className="flex items-center justify-between">
//                       <div className="flex items-center gap-4 text-sm text-gray-500">
//                         <span className="flex items-center gap-1"><EyeIcon className="h-4 w-4" /> {item.views}</span>
//                         <span className="flex items-center gap-1"><ChatBubbleLeftRightIcon className="h-4 w-4" /> {item.comments}</span>
//                       </div>
//                       <div className="flex items-center gap-2">
//                         {isAdmin && (
//                           <>
//                             <button onClick={() => handleEditNews(item)} className="p-1.5 text-blue-600 hover:bg-blue-50 rounded-lg transition">
//                               <PencilIcon className="h-4 w-4" />
//                             </button>
//                             <button onClick={() => setShowDeleteConfirm(item.id)} className="p-1.5 text-red-600 hover:bg-red-50 rounded-lg transition">
//                               <TrashIcon className="h-4 w-4" />
//                             </button>
//                           </>
//                         )}
//                         <button className="text-blue-600 hover:text-blue-700 font-semibold text-sm flex items-center gap-1">
//                           Read More <ArrowRightIcon className="h-4 w-4" />
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </section>
//       )}

//       {/* News Grid */}
//       <section className="py-12">
//         <div className="container mx-auto px-4">
//           <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {filteredNews.map((item) => (
//               <div key={item.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
//                 {item.type === 'video' ? (
//                   <div className="relative w-full h-48 bg-black">
//                     <img src={item.image} alt={item.title} className="w-full h-full object-cover opacity-80" />
//                     <div className="absolute inset-0 flex items-center justify-center">
//                       <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center hover:scale-110 transition">
//                         <svg className="h-6 w-6 text-white" fill="currentColor" viewBox="0 0 24 24">
//                           <path d="M8 5v14l11-7z"/>
//                         </svg>
//                       </div>
//                     </div>
//                     {item.videoUrl && (
//                       <a href={item.videoUrl} target="_blank" rel="noopener noreferrer" className="absolute inset-0"></a>
//                     )}
//                     <span className="absolute bottom-2 right-2 bg-black/70 text-white px-2 py-0.5 rounded text-xs flex items-center gap-1">
//                       <VideoCameraIcon className="h-3 w-3" /> Video
//                     </span>
//                   </div>
//                 ) : (
//                   <img src={item.image} alt={item.title} className="w-full h-48 object-cover" />
//                 )}
//                 <div className="p-5">
//                   <div className="flex items-center gap-2 text-sm text-gray-500 mb-2">
//                     <span className={`px-2 py-0.5 rounded-full text-xs font-semibold
//                       ${item.category === 'sports' ? 'bg-green-100 text-green-700' : 
//                         item.category === 'academic' ? 'bg-blue-100 text-blue-700' : 
//                         item.category === 'cultural' ? 'bg-pink-100 text-pink-700' : 'bg-purple-100 text-purple-700'}`}
//                     >
//                       {item.category.charAt(0).toUpperCase() + item.category.slice(1)}
//                     </span>
//                     <span className="flex items-center gap-1"><CalendarIcon className="h-3 w-3" /> {item.date}</span>
//                     {item.type === 'photo' && (
//                       <span className="flex items-center gap-1 text-blue-600"><PhotoIcon className="h-3 w-3" /></span>
//                     )}
//                   </div>
//                   <h3 className="text-lg font-bold text-gray-800 mb-2 line-clamp-2">{item.title}</h3>
//                   <p className="text-gray-600 text-sm mb-3 line-clamp-2">{item.excerpt}</p>
//                   <div className="flex items-center justify-between">
//                     <span className="text-sm text-gray-500 flex items-center gap-1"><UserIcon className="h-3 w-3" /> {item.author}</span>
//                     <div className="flex items-center gap-1">
//                       {isAdmin && (
//                         <>
//                           <button onClick={() => handleEditNews(item)} className="p-1 text-blue-600 hover:bg-blue-50 rounded transition">
//                             <PencilIcon className="h-3 w-3" />
//                           </button>
//                           <button onClick={() => setShowDeleteConfirm(item.id)} className="p-1 text-red-600 hover:bg-red-50 rounded transition">
//                             <TrashIcon className="h-3 w-3" />
//                           </button>
//                         </>
//                       )}
//                       <button className="text-blue-600 hover:text-blue-700 font-semibold text-sm flex items-center gap-1">
//                         Read More <ArrowRightIcon className="h-3 w-3" />
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Add/Edit News Modal - ONLY VISIBLE TO ADMIN */}
//       {isAdmin && showAddModal && (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto p-6">
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-2xl font-bold text-gray-800">
//                 {editingNews ? 'Edit News/Media' : 'Add News/Media'}
//               </h2>
//               <button onClick={() => setShowAddModal(false)} className="p-2 hover:bg-gray-100 rounded-lg">
//                 <XMarkIcon className="h-6 w-6" />
//               </button>
//             </div>

//             <div className="space-y-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Title *</label>
//                 <input
//                   type="text"
//                   value={newItem.title}
//                   onChange={(e) => setNewItem({...newItem, title: e.target.value})}
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   placeholder="Enter title"
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Category *</label>
//                 <select
//                   value={newItem.category}
//                   onChange={(e) => setNewItem({...newItem, category: e.target.value})}
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 >
//                   <option value="academic">Academic</option>
//                   <option value="sports">Sports</option>
//                   <option value="cultural">Cultural</option>
//                   <option value="events">Events</option>
//                 </select>
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Type *</label>
//                 <select
//                   value={newItem.type}
//                   onChange={(e) => setNewItem({...newItem, type: e.target.value})}
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 >
//                   <option value="news">News</option>
//                   <option value="photo">Photo</option>
//                   <option value="video">Video</option>
//                 </select>
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Date *</label>
//                 <input
//                   type="date"
//                   value={newItem.date}
//                   onChange={(e) => setNewItem({...newItem, date: e.target.value})}
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Author *</label>
//                 <input
//                   type="text"
//                   value={newItem.author}
//                   onChange={(e) => setNewItem({...newItem, author: e.target.value})}
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   placeholder="Enter author name"
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Image URL *</label>
//                 <input
//                   type="text"
//                   value={newItem.image}
//                   onChange={(e) => setNewItem({...newItem, image: e.target.value})}
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   placeholder="Enter image URL"
//                 />
//                 <p className="text-xs text-gray-400 mt-1">For videos, use thumbnail image URL</p>
//               </div>

//               {newItem.type === 'video' && (
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">Video URL</label>
//                   <input
//                     type="text"
//                     value={newItem.videoUrl}
//                     onChange={(e) => setNewItem({...newItem, videoUrl: e.target.value})}
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     placeholder="Enter YouTube URL (e.g., https://youtube.com/@channel)"
//                   />
//                 </div>
//               )}

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Short Description</label>
//                 <input
//                   type="text"
//                   value={newItem.excerpt}
//                   onChange={(e) => setNewItem({...newItem, excerpt: e.target.value})}
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   placeholder="Brief description"
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Full Content</label>
//                 <textarea
//                   rows="3"
//                   value={newItem.content}
//                   onChange={(e) => setNewItem({...newItem, content: e.target.value})}
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   placeholder="Full article content"
//                 />
//               </div>

//               <div className="flex gap-3 pt-4">
//                 <button
//                   onClick={() => setShowAddModal(false)}
//                   className="flex-1 px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleAddNews}
//                   className="flex-1 px-4 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg hover:shadow-lg transition"
//                 >
//                   {editingNews ? 'Update' : 'Add'} News
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Delete Confirmation Modal - ONLY VISIBLE TO ADMIN */}
//       {isAdmin && showDeleteConfirm && (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-2xl max-w-md w-full p-6">
//             <h2 className="text-xl font-bold text-gray-800 mb-4">Confirm Delete</h2>
//             <p className="text-gray-600 mb-6">Are you sure you want to delete this news item? This action cannot be undone.</p>
//             <div className="flex gap-3">
//               <button
//                 onClick={() => setShowDeleteConfirm(null)}
//                 className="flex-1 px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={() => handleDeleteNews(showDeleteConfirm)}
//                 className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* CTA Section */}
//       <section className="py-16 bg-gradient-to-r from-blue-600 to-purple-600 text-white">
//         <div className="container mx-auto px-4 text-center">
//           <RocketLaunchIcon className="h-16 w-16 mx-auto mb-4 text-yellow-300" />
//           <h2 className="text-3xl md:text-4xl font-bold mb-4">
//             Follow Us on <span className="text-yellow-300">Social Media</span>
//           </h2>
//           <p className="text-lg text-blue-100 mb-8 max-w-2xl mx-auto">
//             Stay connected with us on Facebook, Instagram, and YouTube for the latest updates and behind-the-scenes content.
//           </p>
//           <div className="flex flex-wrap justify-center gap-4">
//             <a 
//               href="https://www.facebook.com/share/1B8vT3NNvN/" 
//               target="_blank" 
//               rel="noopener noreferrer"
//               className="bg-[#1877F2] text-white px-6 py-3 rounded-lg font-semibold hover:shadow-lg transition flex items-center gap-2"
//             >
//               <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
//                 <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
//               </svg>
//               Facebook
//             </a>
//             <a 
//               href="https://www.instagram.com/vbpsbhalki/" 
//               target="_blank" 
//               rel="noopener noreferrer"
//               className="bg-gradient-to-r from-pink-500 to-orange-500 text-white px-6 py-3 rounded-lg font-semibold hover:shadow-lg transition flex items-center gap-2"
//             >
//               <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
//                 <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
//               </svg>
//               Instagram
//             </a>
//             <a 
//               href="https://youtube.com/@vidyabharatipublicschoolbhalki" 
//               target="_blank" 
//               rel="noopener noreferrer"
//               className="bg-[#FF0000] text-white px-6 py-3 rounded-lg font-semibold hover:shadow-lg transition flex items-center gap-2"
//             >
//               <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
//                 <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
//               </svg>
//               YouTube
//             </a>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default NewsMedia;


// src/components/website/ComingSoon.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { 
  AcademicCapIcon,
  NewspaperIcon,
  PhotoIcon,
  VideoCameraIcon,
  CalendarIcon,
  ArrowLeftIcon,
  SparklesIcon,
  BellAlertIcon
} from '@heroicons/react/24/outline';

const ComingSoon = ({ 
  pageTitle = 'Coming Soon',
  pageSubtitle = 'This page is under construction',
  pageDescription = 'We\'re working hard to bring you an amazing experience. Please check back soon!',
  icon = 'newspaper' // 'newspaper' | 'photo' | 'video' | 'calendar'
}) => {
  
  // Icon selector
  const icons = {
    newspaper: NewspaperIcon,
    photo: PhotoIcon,
    video: VideoCameraIcon,
    calendar: CalendarIcon
  };
  const IconComponent = icons[icon] || NewspaperIcon;

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-900 via-purple-900 to-blue-900 relative overflow-hidden flex items-center justify-center px-4">
      {/* Background decorations */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-10 left-10 w-72 h-72 bg-blue-400 rounded-full animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-purple-400 rounded-full animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-yellow-400 rounded-full opacity-5 blur-3xl"></div>
      </div>

      {/* Content */}
      <div className="relative max-w-3xl mx-auto text-center text-white py-16">
        {/* School Logo */}
        <div className="mb-8 flex justify-center">
          <div className="w-20 h-20 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-2xl flex items-center justify-center shadow-2xl">
            <AcademicCapIcon className="h-12 w-12 text-white" />
          </div>
        </div>

        {/* School Name */}
        <h2 className="text-2xl md:text-3xl font-bold mb-2">
          <span className="bg-gradient-to-r from-yellow-300 via-yellow-400 to-orange-400 bg-clip-text text-transparent">
            Vidya Bharati
          </span>
          <span className="text-white"> Public School</span>
        </h2>
        <p className="text-blue-200 text-sm mb-10">Bhalki, Karnataka</p>

        {/* Page Icon */}
        <div className="mb-6 flex justify-center">
          <div className="w-24 h-24 bg-white/10 backdrop-blur-lg rounded-3xl flex items-center justify-center border border-white/20 shadow-xl">
            <IconComponent className="h-14 w-14 text-yellow-300" />
          </div>
        </div>

        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-lg rounded-full px-6 py-2 mb-6 border border-white/20">
          <BellAlertIcon className="h-4 w-4 text-yellow-300 animate-pulse" />
          <span className="text-sm font-medium">Under Construction</span>
        </div>

        {/* Main Title */}
        <h1 className="text-4xl md:text-6xl font-bold mb-4">
          {pageTitle}
        </h1>

        {/* Subtitle */}
        <h3 className="text-xl md:text-2xl text-yellow-300 font-semibold mb-4">
          {pageSubtitle}
        </h3>

        {/* Description */}
        <p className="text-lg text-blue-200 max-w-2xl mx-auto mb-10">
          {pageDescription}
        </p>

        {/* Sparkle decoration */}
        <div className="flex items-center justify-center gap-2 mb-10">
          <SparklesIcon className="h-5 w-5 text-yellow-300" />
          <span className="text-sm text-blue-200">Launching very soon</span>
          <SparklesIcon className="h-5 w-5 text-yellow-300" />
        </div>

        {/* Back to Home Button */}
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-gradient-to-r from-yellow-400 to-orange-500 text-gray-900 px-8 py-3 rounded-full font-bold hover:shadow-2xl transition-all duration-300 hover:scale-105"
        >
          <ArrowLeftIcon className="h-5 w-5" />
          Back to Home
        </Link>

        {/* Footer */}
        <p className="mt-10 text-xs text-blue-300">
          © 2026 Vidya Bharati Public School Bhalki. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default ComingSoon;